import { locate } from "@dhx/ts-common/html";
import { Editor } from "../models/Editor";
import { hashToInfo } from "./other";

// range end cannot be set before range start, so if selection backwards range be collapsed
function isSelectionBackwards() {
	const { anchorNode, focusNode, anchorOffset, focusOffset } = window.getSelection();
	const range = document.createRange();
	range.setStart(anchorNode, anchorOffset);
	range.setEnd(focusNode, focusOffset);
	return range.collapsed;
}

export function stateFromDom(editor: Editor) {
	const { anchorNode, anchorOffset, focusNode, focusOffset, isCollapsed } = window.getSelection();

	let leftNode = anchorNode;
	let rightNode = focusNode;
	let leftOffset = anchorOffset;
	let rightOffset = focusOffset;

	if (isSelectionBackwards()) {
		[leftNode, rightNode] = [rightNode, leftNode];
		[leftOffset, rightOffset] = [rightOffset, leftOffset];
	}

	const leftKey = locate(leftNode as any, "dhx_offset");
	const rightKey = locate(rightNode as any, "dhx_offset");

	const leftInfo = hashToInfo(leftKey);
	const rightInfo = hashToInfo(rightKey);

	let left;
	let right;

	if (leftInfo.length === 2) {
		if (leftNode.nodeType === 3) {
			left = {
				blockIndex: leftInfo[0],
				textIndex: leftInfo[1],
				offset: leftOffset,
			};
		} else {
			left = {
				blockIndex: leftInfo[0],
				textIndex: leftInfo[1],
				offset: editor.blocks[leftInfo[0]].textNodes[leftInfo[1]].text.length,
			};
		}
	} else if (leftInfo.length === 1) {
		if (editor.blocks[leftInfo[0]].textNodes[leftOffset]) {
			left = {
				blockIndex: leftInfo[0],
				textIndex: leftOffset,
				offset: 0,
			};
		} else {
			left = {
				blockIndex: leftInfo[0],
				textIndex: leftOffset - 1,
				offset: editor.blocks[leftInfo[0]].textNodes[leftOffset - 1].text.length,
			};
		}
	} else {
		left = {
			blockIndex: leftOffset,
			textIndex: 0,
			offset: 0,
		};
	}

	if (isCollapsed) {
		return {
			range: false,
			left,
		};
	}

	if (rightInfo.length === 2) {
		if (rightNode.nodeType === 3) {
			right = {
				blockIndex: rightInfo[0],
				textIndex: rightInfo[1],
				offset: rightOffset,
			};
		} else {
			right = {
				blockIndex: rightInfo[0],
				textIndex: rightInfo[1],
				offset: editor.blocks[rightInfo[0]].textNodes[rightInfo[1]].text.length,
			};
		}
	} else if (rightInfo.length === 1) {
		if (rightOffset === 0) {
			right = {
				blockIndex: rightInfo[0] - 1,
				...editor.blocks[rightInfo[0] - 1].getBlockEnd(),
			};
		} else {
			right = {
				blockIndex: rightInfo[0],
				textIndex: rightOffset - 1,
				offset: editor.blocks[rightInfo[0]].textNodes[rightOffset - 1].text.length,
			};
		}
	} else {
		right = {
			blockIndex: rightOffset - 1,
			...editor.blocks[rightOffset - 1].getBlockEnd(),
		};
	}

	return {
		left,
		right,
		range: true,
	};
}
